import React from 'react';
import ReactDOM from 'react-dom';
import TopPanel from "./../toppanel.js";
import UserSelection from "./userselection.js";
import TimePicker from "./../timepicker.js"

module.exports = React.createClass({
    getInitialState: function() {
        return {
            changes: {},
            showUserPanel: false,

            showRangeEditPanel: false,
            onceForDuration: false,
            oneTime: HC_LANG.CHL_ONE_TIME,
            setCustomTime: HC_LANG.CHL_SET
        };
    },

    shouldComponentUpdate: function(newProps, newState) {
        if (newProps.selectedId != this.props.selectedId)
            this.setState({showUserPanel: false});
        return true;
    },

    onRangeChange: function (o) {
        let val = o.target.value;
        let isOneTime = val == this.state.oneTime;
        let isSet = val == this.state.setCustomTime;

        let changes = this.state.changes;
        changes.id = this.props.selectedId;
        changes.onceTime = isOneTime;
        if (!isOneTime)
            changes.range = val;

        let newState = {changes: changes, onceForDuration: isOneTime};
        if (isSet)
            newState.showRangeEditPanel = val == this.state.setCustomTime;

        this.setState(newState);
        if (this.props.selectedId == -1)
            this.saveChanges();
    },

    onFieldChange: function(o) {
        let changes = this.state.changes;
        changes.id = this.props.selectedId;
        let dKey = o.target.getAttribute('data-key');

        let val = dKey === 'decrease_temp' ? o.target.checked : o.target.value;
        changes[dKey] = val;

        if (dKey == 'duration') {
            $(this.refs.durationSelect).removeClass('hc-has-error');
        }

        let newState = {changes: changes};
        this.setState(newState);

        if (this.props.selectedId == -1)
            this.saveChanges();
    },
    handleOnDeleteRow: function(o) {
        if (this.props.onDeleteRow) {
            this.props.onDeleteRow(o.target.getAttribute('data-key'));
            $('#must-have-item-error').css('display', 'none').removeClass('hc-f5');
        }
    },
    handleOnCreateRow: function(o) {
        let isItemCorrect = this.state.newRowItem && this.state.newRowItem.trim().length > 0;
        let isActionCorrect = this.state.newRowAction &&  this.state.newRowAction.trim().length > 0;
        if (this.props.onCreateRow) {
            var iName = ReactDOM.findDOMNode(this.refs.new_item_name);
            var aName = ReactDOM.findDOMNode(this.refs.new_action_name);
            if (isItemCorrect && isActionCorrect) {
                this.props.onCreateRow(this.state.newRowItem, this.state.newRowAction);
                this.setState({newRowItem: null, newRowAction: null});
                $(iName).removeClass('hc-has-error');
                $(aName).removeClass('hc-has-error');
                $('#must-have-item-error').css('display', 'none').removeClass('hc-f5');
                iName.focus();
            }
            else {
                if (!isItemCorrect)
                    $(iName).addClass('hc-has-error');
                if (!isActionCorrect)
                    $(aName).addClass('hc-has-error');
            }
        }

    },
    componentDidMount: function() {
        window.addEventListener("keypress", this.checkEnter);
        HC_SubscribeHammerEvent(this.refs.div_edit, "swiperight", this.props.onGoBack);
    },
    componentWillUnmount: function() {
        window.removeEventListener("keypress", this.checkEnter);
        HC_UnsubscribeHammerEvent(this.refs.div_edit, "swiperight");
    },
    componentWillReceiveProps: function() {
        this.resetChanges();
        this.state.newRowItem = this.state.newRowAction = null;
    },
    resetChanges: function() {
        this.setState({changes: {}});
    },
    onRowChanged: function(o) {
        if (o.target.value != undefined)
            $(o.target).removeClass('hc-has-error');

        let chlAtt = o.target.getAttribute("data-type");
        if (chlAtt != undefined & chlAtt != HC_LANG.CHL_TYPE_REG) {
            let parsed = parseInt(o.target.value);
            if (isNaN(parsed)) {
                $(o.target).addClass('hc-has-error');
                return;
            }
        }
        this.setState({[o.target.getAttribute('data-key')]: o.target.value});
    },

    allQuestionsIsValidType: function(questions, type)  {
        if (type == HC_CONST.CL_TYPE_TEMP) {
            return questions.every(function(q) {
                let r = parseFloat(q.action);
                //let isnum = /^\d+((\.|,)\d+)?$/.test(q.action);
                if (isNaN(r)) {
                    $('#must-have-item-error').css('display', 'block').addClass('hc-f5').css('color', '#d0021b').text(HC_LANG.CHL_QUEST_TYPE_ERROR);
                    return false;
                }
                return true;
            });
        }
        $('#must-have-item-error').css('display', 'none').removeClass('hc-f5');
        return true;
    },

    saveChanges: function() {
        // if (!HC_Validate())
        //     return false;
        var checklist = HC_GetItemById(this.props.data, this.props.selectedId);
        var changes = this.state.changes;
        var covertedChanges = {id: parseInt(changes.id)};
        let chListType = changes.checklist_type != undefined ? (changes.checklist_type  == HC_LANG.CHL_TYPE_REG ? 0 : 1 ) : checklist.checklist_type;

        if (changes.name != null)
            covertedChanges.name = changes.name;
        if (changes.everyCount || changes.everyType) {
            covertedChanges.fill_in = checklist.fill_in;

            if (changes.everyCount)
                covertedChanges.fill_in = 'every|' + changes.everyCount + '|' + covertedChanges.fill_in.split('|')[2];
            if (changes.everyType)
                covertedChanges.fill_in = 'every|' + covertedChanges.fill_in.split('|')[1] + '|' + changes.everyType;
        }
        if (changes.errorCount || changes.errorType) {
            covertedChanges.errors_allowed = checklist.errors_allowed;
            if (changes.errorCount)
                covertedChanges.errors_allowed = changes.errorCount + '|' + covertedChanges.errors_allowed.split('|')[1];
            if (changes.errorType)
                covertedChanges.errors_allowed = covertedChanges.errors_allowed.split('|')[0] + '|' + changes.errorType;
        }
        if (changes.everyCount == 0) {
            if (checklist.manual_state == 0 || checklist.id == -1) // switch from automatic to manual
                covertedChanges.manual_state = 1;
        } else {
            covertedChanges.manual_state = 0;
        }
        if (changes.document)
            covertedChanges.linked_document = parseInt(changes.document);
        if (changes.linked_users)
            covertedChanges.linked_users = changes.linked_users;

        if (changes.checklist_type != undefined)
            covertedChanges.checklist_type = changes.checklist_type == HC_LANG.CHL_TYPE_REG ? 0 : 1;

        if (changes.duration) {
            covertedChanges.duration = parseInt(changes.duration);
            if (changes.range == undefined && changes.onceTime)
                covertedChanges.range = changes.duration * 60;
        }
        if (changes.range != undefined) {
            let range = (changes.range == "" || changes.range == this.state.setCustomTime ) ? 0 : parseInt( changes.range < 0 ? changes.range * (-1) : changes.range);
            covertedChanges.range = range;//changes.range == "" ? 0 : parseInt(changes.range);
        }
        if (changes.startup_time)
            covertedChanges.startup_time = changes.startup_time;

        let onceTime = changes.onceTime != undefined ? changes.onceTime : (checklist.once_time);
        covertedChanges.onceTime = onceTime;

        if (changes.decrease_temp)
            covertedChanges.decrease_temp = changes.decrease_temp;

        if (!this.allQuestionsIsValidType(checklist.items, chListType))
            return false;
        if (this.props.onSaveChanges)
            this.props.onSaveChanges(covertedChanges);
        return true;
    },
    addRowFocus: function() {
        $(this.refs.AddRowButton).css('color', '#30ae97');
    },
    addRowUnfocus: function() {
        $(this.refs.AddRowButton).css('color', '');
    },
    checkEnter: function(e) {
        if (e.charCode == 13) {
            var iName = ReactDOM.findDOMNode(this.refs.new_item_name);
            var aName = ReactDOM.findDOMNode(this.refs.new_action_name);
            if (document.activeElement == iName) {
                if (this.refs.new_action_name.value == "")
                    this.refs.new_action_name.focus();
                else
                    this.handleOnCreateRow(null);
            } else if (document.activeElement == aName)
                this.handleOnCreateRow(null);
            else if (this.props.selectedId == -1)
                this.props.onSaveNewChecklist();
        }
    },
    showUserSelectionPanel: function (e) {
        if (!$.isEmptyObject(this.state.changes))
            return HC_Confirm(HC_LANG.CHL_CHG_LOST, HC_LANG.UT_OK, HC_LANG.DUE_CANCEL).then(function () {
                if (this.saveChanges()) {
                    this.setState({showUserPanel: true});
                }
            }.bind(this));
        this.setState({showUserPanel: true});
    },
    onSaveLinkedUserHandler: function (userId, isChecked) {
        if (this.props.selectedId != -1) {
            let data = {'user_id': parseInt(userId), 'checked': isChecked};
            data.checklist_id = parseInt(this.props.selectedId);
            HC_SendRequest('assign_user', data, this.props.successAssignUser);
        }
        else {
            let changes = this.state.changes;
            changes.id = this.props.selectedId;
            if (changes.linked_users == undefined)
                changes.linked_users = [];

            let id = userId == -1 ? -1 : parseInt(userId);
            changes.linked_users.push({'user_id': id, 'checked': isChecked});

            this.setState({changes: changes});
            this.saveChanges();
        }
    },
    getRangePanel: function (checklistRange, duration) {
        let emptyVal = false, splitted, rangeList, rangeInputControl, rangeInputControlOpt, minutesOpt, rangeControls, isStandartVal;
        if (checklistRange == null) {
            checklistRange = this.state.setCustomTime;
            emptyVal = true;
        }

        splitted = checklistRange.toString().split('m');
        if (splitted.length > 1 )
            checklistRange = splitted[0];

        rangeList = [
            {'key': 15, 'value': "15min"},
            {'key': 30, 'value': "30min"},
            {'key': 45, 'value': "45min"},
            {'key': 60, 'value': "60min"},
        ];
        isStandartVal = rangeList.find( (o) => {
            return o.key == checklistRange;
        });

        rangeInputControlOpt = {display: 'inline-block', width: '100%'};
        let rangeOpt = "form-control hc-f4 hc-btn-opt hc-range";
        let isOnce = this.state.onceForDuration || checklistRange == duration * 60;

        // custom value
        if (!(this.state.showRangeEditPanel || ($.isEmptyObject(isStandartVal) & !emptyVal) & !isOnce))
        {
            // standart value
            let isActive = "";
            rangeControls = rangeList.map(function (o, i) {
                isActive = (!isOnce && o.key == checklistRange) ? " active" : "";
                return (
                    <input key={i} disabled className={rangeOpt + isActive} type="text" data-key="range" range-val={o.key}
                           value={o.value} onClick={this.onRangeChange}/>
                )
            }.bind(this));

            isActive = (!isOnce && checklistRange == this.state.setCustomTime) ? " active" : "";
            rangeControls.push(<input key="4" disabled className={rangeOpt + (isOnce ? " active" : "")} type="text" data-key="range" range-val="Once"
                                      value={this.state.oneTime} onClick={this.onRangeChange}  style={{width: '50%'}} />);

            rangeControls.push(<input ref="hc_set_tiem" key="5" disabled className={rangeOpt + " hc-validated" + isActive} type="text" data-key="range" range-val="" data-vfunc="HC_ChecklistValidation_Range"
                                      value={this.state.setCustomTime} onClick={this.onRangeChange} style={{width: '50%'}} />);
            rangeInputControlOpt = {display: "none", width: "0"};
        }
        rangeInputControl = (
            <span style={rangeInputControlOpt}>
                <input ref="range_manual" type="text" className="form-control hc-f4 hc-validated"  value={checklistRange === this.state.setCustomTime ? "" : checklistRange} autoFocus={true}
                       data-key='range' onChange={this.onFieldChange} data-vfunc="HC_ValidateNotEmptyField" style={{width: '25%',display: 'inline' }}/>
                <div className="hc-f4 hc-f-l" style={{width: '25%', textAlign: 'center', display: "inline-block"}}>min</div>
                <input key="6" disabled className={rangeOpt} type="text" data-key="range"
                       value={this.state.oneTime} onClick={() => {
                    if (duration == undefined) {
                        $(this.refs.durationSelect).addClass('hc-has-error');
                        return;
                    }
                    let changes = this.state.changes;
                    changes.id = this.props.selectedId;
                    changes.range = duration * 60;
                    changes['onceTime'] = true;
                    $(this.refs.durationSelect).removeClass('hc-has-error');
                    this.setState({changes: changes, showRangeEditPanel: false, onceForDuration: true});
                    if (this.props.selectedId == -1)
                        this.saveChanges();
                }} style={{width: '50%'}} />
            </span>);

        return (
            <div className="hc-flex-display hc-field-label">
                <div className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_RANGE}</div>
                <div className="hc-field-inner">
                    <span> {rangeInputControl} {rangeControls} </span>
                </div>
            </div>
        );
    },
    getTimePanel: function (time) {
        return (
            <div className="hc-flex-display hc-field-label">
                <div className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_START_TIME}</div>
                <div className="hc-field-inner">
                    <TimePicker dataKey="startup_time" style={{width: '50%'}} handleChangeValue={this.onFieldChange} time={time}/>
                </div>
            </div>)
    },
    ensureGlobalValidationFunctionsCreated: function (item) {

        let timeControl = $("input.rc-time-picker-input");
        if (timeControl && item && item.checklist_type == 1) {
            // add attribute
            let attr = timeControl.attr("data-vfunc");
            if (!attr)
                $(timeControl).attr("data-vfunc", "HC_ValidateNotEmptyField").addClass("hc-validated");
        }

        if (window.HC_CHECKLIST_VALIDATION != this) {
            window.HC_CHECKLIST_VALIDATION = this;

            window.HC_ChecklistValidation_Range = function(str) {
                //return $(".hc-btn-opt[value='Set']").hasClass("active") ? [false, ""] : [true, ""];
                return $(this.refs.hc_set_tiem).hasClass("active") ? [false, ""] : [true, ""];
            }.bind(this);

            window.HC_ValidateDuration_Select = function (str) {
                return (str !== HC_LANG.SU_CHOOSE ? [true, ""] : [false, HC_LANG.SU_FIELD_DONT_EMPTY])
            };
        }
    },

    render: function() {
        if (this.state.changes.id != this.props.selectedId)
            this.state.changes = {}; // clear changes for new item

        let checklist = HC_GetItemById(this.props.data, this.props.selectedId);
        let createMode = this.props.selectedId == -1;

        this.ensureGlobalValidationFunctionsCreated(checklist);

        var content;
        if (checklist) {
            var documentOptions = this.props.documents.map(function (o) {
                return (<option key={o.id} value={o.id}>{o.name}</option>);
            });

            var div100 = {display: "inline-block", marginBottom: "0"};
            div100['flex'] = div100['WebkitFlex'] = "1 1 200px";
            var input50 = {width: "50%", display: "inline"};
            var tableInput = {width: '100%', height: '100%', border: 0, boxShadow: 'initial', paddingLeft: "15px"};

            var splitFill = checklist.fill_in.split('|');
            var splitError = checklist.errors_allowed.split('|');

            var changes = this.state.changes;
            var newName = changes.name != undefined ? changes.name : checklist.name;
            var everyCount = changes.everyCount ? changes.everyCount : splitFill[1];
            var everyType = changes.everyType ? changes.everyType : splitFill[2];
            var errorCount = changes.errorCount ? changes.errorCount : splitError[0];
            var errorType = changes.errorType ? changes.errorType : splitError[1];
            var linkedDoc = changes.document ? changes.document : (checklist.linked_document);
            var linkedUsers = changes.linked_users ? changes.linked_users : checklist.linked_users;
            var manual = (changes.everyCount) ? changes.everyCount == 0 : (checklist.manual_state != 0);
            let checklistType = changes.checklist_type ? changes.checklist_type : (checklist.checklist_type ? HC_LANG.CHL_TYPE_TEMP : HC_LANG.CHL_TYPE_REG);
            let duration = changes.duration ? changes.duration : checklist.duration;
            let range = changes.range != undefined ? changes.range : checklist.range;
            let startup_time = changes.startup_time ? changes.startup_time : checklist.startup_time;
            //let onceTime = changes.onceTime ? changes.onceTime : (checklist.once_time);

            let decrTemp = changes.decrease_temp != undefined ? changes.decrease_temp : checklist.decrease_temp;

            if (range == 0)
                range = '';
            if (!linkedDoc)
                linkedDoc = 0;

            let reqularOpt, temperatureOpt, isReqular;
            isReqular = checklistType === HC_LANG.CHL_TYPE_REG;


            var rows = checklist.items.map(function (o) {
                var delTd = o.temp ? (<td key="3"/>) : (
                    <td key="3" className="hc-hover" style={{textAlign: "center", cursor: "pointer"}} data-key={o.id}
                        onClick={this.handleOnDeleteRow}>
                        <i data-key={o.id} className="fa fa-trash-o hc-fa-medium hc-fa-action"/></td>);
                let columnStyle = {paddingLeft: '30px', wordWrap: "break-word"};
                return (
                    <tr key={o.id}>
                        <td key="1" style={columnStyle}>{o.item}</td>
                        <td key="2" style={columnStyle}>{(checklist.checklist_type == 0) ? o.action : o.action + (isReqular ? "" : " °C")}</td>
                        {delTd}
                    </tr>
                );
            }.bind(this));

            let savePanel;
            if (!$.isEmptyObject(this.state.changes) && !createMode) {
                savePanel = (<div style={{textAlign:"center", marginTop: "5%"}}>
                    <button type='button' className='hc-button' onClick={this.saveChanges}>Save</button>
                    <label type='button' className='hc-dialog-cancel hc-f3' onClick={this.resetChanges}
                           style={{marginLeft:"1rem", verticalAlign:"sub"}}>Cancel</label>
                </div>);
            } else {
                savePanel = (<div></div>);
            }

            var ricon, riconAction, nameInput, header, licon, liconAction, mustHaveItem;
            mustHaveItem = (<div style={{marginLeft:'2rem', marginTop: "2%"}}>
                <div id="must-have-item-error" style={{display: 'none'}}></div>
            </div>);

            if (createMode) {
                ricon = "fa-floppy-o hc-fa-action ";
                riconAction = this.props.onSaveNewChecklist;
                header = HC_LANG.CHL_CREATE_CHL;
                nameInput = (<div className="hc-flex-display hc-field-label" >
                    <div  className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_NAME}</div>
                    <div className="hc-field-inner">
                        <input type="text" className="form-control hc-f4 hc-validated" value={newName}
                               data-key='name' onChange={this.onFieldChange} data-vfunc="HC_ValidateNotEmptyField"/>
                    </div>
                </div>);
                // mustHaveItem = (<div style={{marginLeft:'2rem', marginTop: "2%"}}>
                //     <div id="must-have-item-error" style={{display: 'none'}}></div>
                // </div>);
            } else {
                header = checklist.name;
                ricon = "fa-trash-o";
                riconAction = this.props.onDelete;
            }

            let goBack, goBackAction;
            if (this.props.goBackEnabled) {
                goBack = "fa-angle-left";
                goBackAction = this.props.onGoBack;
            }

            let deviceType = HC_DeviceType();
            if (createMode || deviceType !== HC_CONST.SCR_DESCKTOP) {
                licon = goBack;
                liconAction = goBackAction;
            }

            let everyTypeCombo;
            if (!manual) {
                let everyOptions = [];
                if (isReqular)
                    everyOptions.push(<option key="0" value="ampm">{HC_LANG.CHL_MORN_AFT}</option>);
                everyOptions.push(<option key="1" value="d">{HC_LANG.CHL_DAY}</option>);
                everyOptions.push(<option key="2" value="w">{HC_LANG.CHL_WEEK}</option>);
                everyOptions.push(<option key="3" value="m">{HC_LANG.CHL_MONTH}</option>);

                everyTypeCombo = (<select className="form-control hc-f4" value={everyType} data-key='everyType' onChange={this.onFieldChange} style={input50}>
                    {everyOptions}
                </select>)
            }

            let editNamePanel = null;
            if (!createMode) {
                editNamePanel = (<div className="hc-flex-display hc-field-label" >
                    <div  className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_NAME}</div>
                    <input className="form-control hc-f4 hc-field-inner hc-validated " data-key='name'
                           data-vfunc="HC_ValidateNotEmptyField"
                           onChange={this.onFieldChange} value={newName}/>
                </div>)
            }

            reqularOpt = "form-control hc-f4 hc-btn-opt " + (isReqular ? "active" : "");
            temperatureOpt = "form-control hc-f4 hc-btn-opt " + (!isReqular ? "active" : "");

            let durationPanel, rangePanel, errorsPanel, exactTimePanel, inverTemperaturePanel;
            errorsPanel = (
                <div className="hc-flex-display hc-field-label" >
                    <div
                        className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_ERR_ALLOW_PERITEM}</div>
                    <div className="hc-field-inner">
                        <select className="form-control hc-f4" value={errorCount} data-key='errorCount'
                                onChange={this.onFieldChange} style={input50}>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                        </select>
                        <select className="form-control hc-f4" value={errorType} data-key='errorType'
                                onChange={this.onFieldChange} style={input50}>
                            <option value="d">{HC_LANG.CHL_PER_DAY}</option>
                            <option value="w">{HC_LANG.CHL_PER_WEEK}</option>
                            <option value="m">{HC_LANG.CHL_PER_MONTH}</option>
                        </select>
                    </div>
                </div>);

            if (!isReqular) {
                let durationOptions = [];
                for(var i = 1; i < 24; i++)
                    durationOptions.push(<option key={i} value={i}>{i + " " + HC_LANG.CHL_HOURS}</option>)

                // add two panel and hide one
                errorsPanel = null;
                durationPanel = (
                    <div className="hc-flex-display hc-field-label" >
                        <div className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_DURATION}</div>
                        <div className="hc-field-inner">
                            <select ref="durationSelect" className="form-control hc-f4 hc-validated" value={duration} data-key='duration'
                                    onChange={this.onFieldChange} data-vfunc="HC_ValidateDuration_Select">
                                <option key="0" value={null}>{HC_LANG.SU_CHOOSE}</option>
                                {durationOptions}
                            </select>
                        </div>
                    </div>
                );

                rangePanel = this.getRangePanel(range, duration);
                if (!manual) {
                    exactTimePanel = this.getTimePanel(startup_time);
                }

                inverTemperaturePanel = <div className="hc-flex-display hc-field-label" >
                    <div className="hc-f3 hc-f-l hc-field-caption">Decrease temperature</div>
                    <div className="hc-field-inner">
                        <input type="checkbox" className="big-checkbox" value={decrTemp} data-key='decrease_temp'
                                onChange={this.onFieldChange} checked={decrTemp}/>
                    </div>
                </div>
            }


            if (this.state.showUserPanel) {
                header = HC_LANG.ADM_ASSUS_CAPTION + " " + checklist.name;
                licon = "fa-angle-left";
                liconAction = (() => {
                    this.setState({showUserPanel: false})
                }).bind(this);
                ricon = riconAction = null;
                content = <UserSelection ref="hc_us" allUsers={this.props.allUsers} users={linkedUsers} checklistId={checklist.id}
                                         saveLinkedUser={this.onSaveLinkedUserHandler}
                />
            }
            else {
                content = (
                    <div>
                        <div style={{padding: "5%", paddingBottom: '2%', paddingLeft: '30px'}}>
                            {nameInput}
                            {editNamePanel}

                            <div className="hc-flex-display hc-field-label" >
                                <div  className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_TYPE}</div>
                                <div className="hc-field-inner">
                                    <span>
                                        <input disabled className={reqularOpt} type="text" data-key='checklist_type'
                                               value={HC_LANG.CHL_TYPE_REG} onClick={this.onFieldChange}/>
                                        <input disabled className={temperatureOpt} type="text" data-key='checklist_type'
                                               value={HC_LANG.CHL_TYPE_TEMP} onClick={this.onFieldChange}/>
                                    </span>
                                </div>
                            </div>

                            {durationPanel}
                            {rangePanel}

                            <div className="hc-flex-display hc-field-label" >
                                <div  className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_HAS_FILLIN}</div>
                                <div className="hc-field-inner">
                                    <select className="form-control hc-f4" data-key='everyCount'
                                            onChange={this.onFieldChange} value={everyCount}
                                            style={manual ? div100 : input50}>
                                        <option value="0">{HC_LANG.CHL_MANUALLY}</option>
                                        <option value="1">{HC_LANG.CHL_EVERY}</option>
                                        <option value="2">{HC_LANG.CHL_EVERY_OTHER}</option>
                                        <option value="3">{HC_LANG.CHL_EVERY} 3</option>
                                        <option value="4">{HC_LANG.CHL_EVERY} 4</option>
                                        <option value="5">{HC_LANG.CHL_EVERY} 5</option>
                                        <option value="6">{HC_LANG.CHL_EVERY} 6</option>
                                        <option value="7">{HC_LANG.CHL_EVERY} 7</option>
                                        <option value="8">{HC_LANG.CHL_EVERY} 8</option>
                                        <option value="9">{HC_LANG.CHL_EVERY} 9</option>
                                        <option value="10">{HC_LANG.CHL_EVERY} 10</option>
                                    </select>
                                    {everyTypeCombo}
                                </div>
                            </div>

                            {exactTimePanel}
                            {inverTemperaturePanel}
                            {errorsPanel}

                            <div className="hc-flex-display hc-field-label" >
                                <div  className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.CHL_LINKED_DOC}</div>
                                <div className="hc-field-inner">
                                    <select className="form-control hc-f4" value={linkedDoc} data-key='document'
                                            onChange={this.onFieldChange}>
                                        <option value="-1">{HC_LANG.CHL_NO}</option>
                                        {documentOptions}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <AssignedUserInfo allUsers={this.props.allUsers} checkedUsersId={linkedUsers}
                                          showUsersOnClick={this.showUserSelectionPanel}/>

                        {savePanel}
                        {mustHaveItem}

                        <div style={{position: "relative", marginTop: '1rem'}}>
                            <div style={{position: "absolute", left: "-2px", right: "-2px", top: 0, bottom: 0}}>
                                <table className="table table-bordered hc-table hc-f3"
                                       style={{width: "100%", tableLayout: "fixed"}}>
                                    <thead>
                                    <tr>
                                        <th style={{paddingLeft: '15px'}}>
                                            <input ref="new_item_name" className="form-control hc-f3" type="text"
                                                   placeholder={HC_LANG.CHL_ADD_ITEM}
                                                   data-key="newRowItem" value={this.state.newRowItem}
                                                   onChange={this.onRowChanged}
                                                   style={tableInput} onFocus={this.addRowFocus}
                                                   onBlur={this.addRowUnfocus}/>
                                        </th>
                                        <th style={{paddingLeft: '15px'}}>
                                            <input ref="new_action_name" className="form-control hc-f3" type="text"
                                                   placeholder={ isReqular ? HC_LANG.CHL_ADD_ACTION : HC_LANG.CHL_ADD_TEMP} data-key="newRowAction" data-type={checklistType}
                                                   value={this.state.newRowAction}
                                                   onChange={this.onRowChanged} style={tableInput}
                                                   onFocus={this.addRowFocus} onBlur={this.addRowUnfocus}/>
                                        </th>
                                        <th className="hc-hover"
                                            style={{
                                                textAlign: "center",
                                                cursor: "pointer",
                                                paddingLeft: '1.2rem',
                                                paddingRight: '1.2rem',
                                                width: "79px"
                                            }}
                                            onClick={this.handleOnCreateRow}>
                                            <i ref="AddRowButton"
                                               className="fa fa-plus-circle hc-fa-medium hc-fa-action"/>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {rows}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return (
            <div style={{position:"relative", width:'100%', height:'100%'}}>
                <TopPanel text={header} licon={licon} onLiconClick={liconAction} ricon={ricon} onRiconClick={riconAction}/>
                <div ref="div_edit" style={{position:"absolute", top:'60px', width:'100%', bottom:0, overflowX:'hidden', overflowY:"auto", WebkitOverflowScrolling:'touch'}}>
                    {content}
                </div>
            </div>
        );
    }
});


class AssignedUserInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {

        var labelStyle = {padding: "3% 5% 0% 30px", display: "flex"};
        labelStyle['flexFlow'] = labelStyle['WebkitFlexFlow'] = "row wrap";
        var div100 = {display: "inline-block", marginBottom: "0", cursor: "pointer", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"};
        div100['flex'] = div100['WebkitFlex'] = "1 1 200px";

        var ricon = "fa hc-fa-medium hc-fa-action fa-angle-right";
        var riconStyle = {
            flex: "0 1 auto",
            WebkitFlex:"0 1 auto"
        };

        let props = this.props;
        let infoMessage = "";//"Assigned to ";
        let userNames = '';
        let allAssigned = true;

        for(var i = 0; i < props.checkedUsersId.length; i++) {
            let user = props.allUsers.find((o) => {
                return o.id === props.checkedUsersId[i].user_id
            });
            if (user != undefined && props.checkedUsersId[i].checked) {
                userNames += user.name + ', ';
            }
            else
                allAssigned = false;
        }
        infoMessage += userNames.substring(0, userNames.length - 2);
        if (userNames.length == 0)
            infoMessage = HC_LANG.ADM_NO_ASSUSERS;
        if (props.checkedUsersId.length == props.allUsers.length & allAssigned)
            infoMessage = HC_LANG.ADM_ASSIGNED_ALLUSERS;

        return (
            <div className="hc-flex-display hc-bt" style={labelStyle}>
                <div className="hc-f3 hc-f-l hc-field-caption">{HC_LANG.ADM_ASSIGNED_USERS}</div>
                <div className="hc-f3 hc-green" style={div100} onClick={this.props.showUsersOnClick}>{infoMessage}</div>
                <div className="hc-hover" style={{marginRight: "1%", cursor: "pointer"}} onClick={this.props.showUsersOnClick}>
                    <i className={ricon} style={riconStyle}></i>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./checklists/checklistedit.js